import { useMemo } from 'react';
import { z, AnyZodObject } from 'zod';

export function createValidationHook<TSchema extends AnyZodObject>(
  schema: TSchema
) {
  return function useValidation(state: z.infer<TSchema>) {
    const validationErrors = useMemo(() => {
      const result = schema.safeParse(state); // Assume no async validations, those would need something heavier than this hook can provide
      if (result.success) return [];
      return result.error.issues;
    }, [state]);
    return validationErrors;
  };
}
